import React from 'react';
import { Globe } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Official Brand SVG Icons with accurate geometries & brand colors
 */

export const WhatsAppIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('inline-block shrink-0', className)}
  >
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2ZM12.05 20.15C10.57 20.15 9.12 19.75 7.85 19L7.55 18.82L4.43 19.64L5.26 16.6L5.06 16.29C4.24 14.98 3.8 13.47 3.8 11.91C3.8 7.37 7.5 3.67 12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.05 20.15ZM16.57 14.41C16.32 14.29 15.1 13.69 14.87 13.6C14.64 13.52 14.48 13.48 14.31 13.73C14.15 13.98 13.68 14.54 13.53 14.71C13.39 14.88 13.24 14.9 12.99 14.78C12.74 14.65 11.94 14.39 10.99 13.54C10.25 12.88 9.75 12.06 9.6 11.81C9.46 11.56 9.59 11.43 9.71 11.31C9.82 11.2 9.96 11.02 10.09 10.87C10.21 10.72 10.25 10.62 10.33 10.45C10.42 10.28 10.37 10.14 10.31 10.02C10.25 9.9 9.75 8.68 9.55 8.18C9.35 7.69 9.14 7.76 8.99 7.75C8.84 7.74 8.68 7.74 8.51 7.74C8.35 7.74 8.08 7.8 7.85 8.05C7.62 8.3 6.98 8.9 6.98 10.12C6.98 11.34 7.87 12.51 8 12.68C8.12 12.85 9.75 15.36 12.24 16.44C12.83 16.7 13.29 16.85 13.65 16.97C14.25 17.16 14.79 17.13 15.22 17.07C15.7 17 16.7 16.46 16.91 15.88C17.11 15.3 17.11 14.8 17.05 14.7C16.99 14.6 16.82 14.54 16.57 14.41Z" />
  </svg>
);

export const MessengerIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('inline-block shrink-0', className)}
  >
    <path d="M12 2C6.477 2 2 6.145 2 11.26C2 14.177 3.327 16.762 5.4 18.47V22L8.769 20.151C9.791 20.435 10.872 20.587 12 20.587C17.523 20.587 22 16.442 22 11.327C22 6.212 17.523 2 12 2ZM13.064 14.51L10.518 11.789L5.549 14.51L11.011 8.706L13.633 11.427L18.526 8.706L13.064 14.51Z" />
  </svg>
);

export const InstagramIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('inline-block shrink-0', className)}
  >
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);

export const WebsiteIcon = ({ className }: { className?: string }) => (
  <Globe className={cn('inline-block shrink-0', className)} />
);

export const ShopifyIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('inline-block shrink-0', className)}
  >
    <path d="M19.462 7.708a.747.747 0 0 0-.67-.215l-1.427.247c-.01-.07-.023-.14-.037-.213a4.01 4.01 0 0 0-3.957-3.277c-.12 0-.24.006-.36.018a3.95 3.95 0 0 0-3.567 2.375l-1.39.24a.754.754 0 0 0-.612.632L6.1 16.892a.753.753 0 0 0 .614.86l10.518 1.823a.752.752 0 0 0 .874-.614l1.47-10.638a.748.748 0 0 0-.114-.615zM13.25 5.86c.645-.04 1.25.176 1.7.59l-2.02.35-.418-.89a2.532 2.532 0 0 1 .738-.05zm-2.08 1.13c.277-.55.727-.978 1.272-1.21l.53 1.127-1.802.313v-.23zm.88 1.79l2.793-.484.544 3.125-3.337.58-.544-3.125v-.096zm-4.32 8.35l1.096-7.92 2.384-.413.57 3.278a.75.75 0 0 0 .874.613l3.655-.634.39 2.24-6.33 1.1a.752.752 0 0 0-.615.874l.27 1.556-2.294-.694zm10.37-1.8l-1.026 1.89-1.81-.314-.38-2.18 2.05-.355 1.166.959z" />
  </svg>
);
